"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResolutionAndBitrateRestrictions = exports.getDeviceRestrictions = void 0;
const common_1 = require("../../device/common");
// exported for unit-tests
function getDeviceRestrictions() {
    // LG SmartTV
    if ((0, common_1.isLGTV)()) {
        return new Promise((resolve) => {
            // this timeout _should_ never happen as the callback is seemingly called instantly
            const timeout = setTimeout(() => resolve({}), 1000);
            window.webOS.deviceInfo(({ uhd }) => {
                clearTimeout(timeout);
                if (uhd) {
                    resolve({});
                }
                else {
                    resolve({
                        maxResHeight: 1080,
                    });
                }
            });
        });
    }
    return Promise.resolve({});
}
exports.getDeviceRestrictions = getDeviceRestrictions;
function getResolutionAndBitrateRestrictions(contractRestrictions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const restrictions = {
            minBitrate: contractRestrictions.minBitrate,
            maxBitrate: contractRestrictions.maxBitrate,
            maxResHeight: contractRestrictions.maxResHeight,
        };
        const deviceRestrictions = yield getDeviceRestrictions();
        if (deviceRestrictions.maxResHeight &&
            (!restrictions.maxResHeight ||
                restrictions.maxResHeight > deviceRestrictions.maxResHeight)) {
            restrictions.maxResHeight = deviceRestrictions.maxResHeight;
        }
        return Promise.resolve(restrictions);
    });
}
exports.getResolutionAndBitrateRestrictions = getResolutionAndBitrateRestrictions;
//# sourceMappingURL=restrictions.js.map